export const bookingConstants = {
	LUNCH: 'lunch',
	BOOKING: 'booking',
	TRANSPORT: 'transport',
	CUSTOM: 'custom',
	
	MEETING_ROOM: 'meeting_room',
	
	TIMESLOT: 'timeslot',
	BUILDING: 'building',
	FLOOR: 'floor',
	ROOM: 'room',
	TABLE: 'table',
};

export const bookingKindList = [
	bookingConstants.BOOKING,
	bookingConstants.LUNCH,
	bookingConstants.TRANSPORT,
	bookingConstants.CUSTOM,
];

export const bookingOptions = {
	MYSELF: 'myself',
	MYSELF_AND_COWORKERS: 'myself_and_coworkers',
	COWORKERS: 'coworkers',
	EXTERNAL: 'external',
}

export const bookingStatus = {
	INVITED: 'invited',
	INVITE_ACCEPTED: 'invite_accepted',
	INVITE_REJECTED: 'invite_rejected',
	CANCELLED: 'cancelled',
	ACTIVE: 'active',
	MANUAL_VALIDATION: 'manual_validation',
	EXPIRED: 'expired',
}

export const bookingStatusActiveCount = [
	bookingStatus.ACTIVE,
	bookingStatus.INVITED,
	bookingStatus.INVITE_ACCEPTED,
	bookingStatus.MANUAL_VALIDATION,
	bookingStatus.EXPIRED,
];

export const bookingStatusActive = [
	bookingStatus.ACTIVE,
	bookingStatus.INVITE_ACCEPTED,
	bookingStatus.MANUAL_VALIDATION,
	bookingStatus.EXPIRED,
]

export const isBookForMyself = ( bookFor ) => {
	return [ bookingOptions.MYSELF, bookingOptions.MYSELF_AND_COWORKERS ].includes( bookFor )
}
